module.exports = __webpack_public_path__ + "img/SOKAL-WEB-112822-CreativeAnalysis-GMC-Playful.bbbf9664.jpeg";